import React from 'react'

function Dots({ activeIndex, onclick, dataTestimonials }) {
  return (
    <div className='all-dots mt-8'>
      {dataTestimonials.map((slide, index) => (
        <span
          key={index}
          className={`${activeIndex === index ? ' dot active-dot' : 'dot'}`}
          onClick={() => onclick(index)}
        ></span>
      ))}
    </div>
  )
}

export default Dots